module.exports = __webpack_public_path__ + "static/media/logo_bilan.f5482ec4.png";